var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUiBoxTestedSolution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 591.902,
    height: 291.077,
    viewBox: "0 0 591.902 291.077",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI_box_tested_solution",
    transform: "translate(14.031 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_615",
    "data-name": "Raggruppa 615",
    transform: "translate(-14.031)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_140",
    "data-name": "Tracciato 140",
    d: "M24.948,238.561,9.4,231.889,0,88.645V-3.224L9.4-52.515,580.01-47.234,591.9-16.069,580.01,231.889l-165.659,6.672",
    transform: "translate(0 52.515)",
    fill: "#807cc6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiBoxTestedSolution);
export default __webpack_public_path__ + "static/media/UI_box_tested_solution.2368f189d2179ce24e609649c694c7d0.svg";
export { ForwardRef as ReactComponent };